export default __webpack_public_path__ + "static/media/unionpay.e314575e.svg";